module.exports = __webpack_public_path__ + "front/img/bmbg01.e86b671e.png";